import React from 'react';
import { Search, FileCheck, PenTool, Hammer, CheckCircle } from 'lucide-react';

const Process = () => {
  const steps = [
    {
      icon: <Search className="w-8 h-8" />,
      title: 'Initial Consultation',
      description: 'Understanding your requirements, plot details, and project objectives',
      number: '01'
    },
    {
      icon: <FileCheck className="w-8 h-8" />,
      title: 'Feasibility Analysis',
      description: 'Comprehensive site analysis, market research, and viability assessment',
      number: '02'
    },
    {
      icon: <PenTool className="w-8 h-8" />,
      title: 'Design & Planning',
      description: 'Creating detailed plans, elevations, landscapes, and documentation',
      number: '03'
    },
    {
      icon: <Hammer className="w-8 h-8" />,
      title: 'Execution Support',
      description: 'Implementation guidance, approvals, and construction oversight',
      number: '04'
    },
    {
      icon: <CheckCircle className="w-8 h-8" />,
      title: 'Sales & Delivery',
      description: 'Marketing, sales execution, and assured inventory clearance',
      number: '05'
    }
  ];

  return (
    <section id="process" className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-testid="process-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="gradient-text">Process</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A systematic approach ensuring success at every stage
          </p>
        </div>

        <div className="relative">
          {/* Timeline line - hidden on mobile */}
          <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gray-200"></div>

          <div className="space-y-12">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`relative flex flex-col lg:flex-row items-center gap-8 ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}
                data-testid={`process-step-${index}`}
              >
                {/* Content Card */}
                <div className="w-full lg:w-5/12">
                  <div className="bg-white border-2 border-gray-200 rounded-xl p-6 card-hover hover:border-gray-400 transition-all duration-300">
                    <div className="flex items-start space-x-4">
                      <div className="w-14 h-14 bg-gray-100 rounded-lg flex items-center justify-center text-gray-900 flex-shrink-0">
                        {step.icon}
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center justify-between mb-2">
                          <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                          <span className="text-3xl font-bold text-gray-200">{step.number}</span>
                        </div>
                        <p className="text-gray-600">{step.description}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Center Circle */}
                <div className="hidden lg:flex absolute left-1/2 transform -translate-x-1/2 w-8 h-8 bg-gray-900 rounded-full border-4 border-white shadow-lg z-10"></div>

                {/* Spacer for alternating layout */}
                <div className="hidden lg:block w-5/12"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;